import { render, staticRenderFns } from "./HelloPage.vue?vue&type=template&id=2f0b040b&scoped=true&"
import script from "./HelloPage.vue?vue&type=script&lang=js&"
export * from "./HelloPage.vue?vue&type=script&lang=js&"
import style0 from "./HelloPage.vue?vue&type=style&index=0&id=2f0b040b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b040b",
  null
  
)

export default component.exports